module.exports = __webpack_public_path__ + "static/persuader-8f54a9adc5941654092fc032b89ba560.jpg";